import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { AdminTaskType } from '../../../../../constants';
import AdminKaplanImportTaskData from './admin-kaplan-import-task-data';

const AdminTaskData = ({ taskType, data }) => {
  return <div id='admin-task-data'>
    {
      taskType === AdminTaskType.kaplanImport ? <AdminKaplanImportTaskData data={JSON.parse(data)} /> : null
    }
  </div>
}

const mapStateToProps = ({ admin }) => ({
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidUpdate(prevProps) {
    }
  })
)(AdminTaskData)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/partials/admin-task-data.js